//@flow

import {
  GetMetadataQuery,
  GetMetadataMsg,
  FuidRrnInfo,
  GetMetadataResp,
  KeyValuePair
} from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import ViewUtil from '../../ViewUtil';

export default class GetMetadata {
  assetInfo: Array<FuidRrnInfo>;
  updateInCache: boolean;
  audioOrVideo: boolean;
  fetchAiData: boolean;
  sortyBy: string;
  aiDataGroupBy: string;
  aiDataStartIndex: number;
  aiDataLimit: number;

  filterMetadatas: Array<KeyValuePair>;

  constructor(assetInfo: Array<FuidRrnInfo>, updateInCache: boolean = true) {
    this.assetInfo = assetInfo;
    this.updateInCache = updateInCache;
  }

  addMetadataToFilter(metadataKey: string, value: ?string = undefined): void {
    if (!this.filterMetadatas) this.filterMetadatas = [];
    this.filterMetadatas.push(new KeyValuePair().setKey(metadataKey).setValue(value));
  }

  setAiDataGroupBy(aiDataGroupBy: string): GetMetadata {
    this.aiDataGroupBy = aiDataGroupBy;
    return this;
  }

  setAiDataLimit(aiDataLimit: number): GetMetadata {
    this.aiDataLimit = aiDataLimit;
    return this;
  }

  setAiDataStartIndex(aiDataStartIndex: number): GetMetadata {
    this.aiDataStartIndex = aiDataStartIndex;
    return this;
  }

  /**
   * If fetching ai data, setting this value makes sense as we want to group data differently for Images and video.
   * So, call this method is going to be fetched AI data is Video or audio.
   * @param {boolean} v
   */
  setAudioOrVideo(v: boolean): GetMetadata {
    this.audioOrVideo = v;
    if (this.audioOrVideo) this.sortyBy = 'startTime';
    return this;
  }

  /**
   * Call this method with value true to enable the fetching of AI data.
   * @param {boolean} v
   */
  setFetchAiData(v: boolean): GetMetadata {
    this.fetchAiData = v;
    return this;
  }

  run(): Promise<GetMetadataResp> {
    return new Promise((onSuccess, onFailure) => {
      const query: GetMetadataQuery = new GetMetadataQuery();
      const msg: GetMetadataMsg = new GetMetadataMsg();

      if (this.sortyBy) msg.setAiDataSortBy(this.sortyBy);
      msg.setFetchAiData(this.fetchAiData);
      msg.setAiDataGroupBy(this.aiDataGroupBy);
      msg.setAiDataLimit(this.aiDataLimit);
      msg.setAiDataStartIndex(this.aiDataStartIndex);

      let cid: number = ViewUtil.getCollectionIdFromArgs();
      if (cid > 0) {
        msg.setCollectionId(cid);
      }
      msg.setFuidList(this.assetInfo);
      msg.setUpdateInCache(this.updateInCache);
      msg.setMetadataFilters(this.filterMetadatas);
      // msg.setAiDataSortBy('startTime');
      query.message = msg;
      query.run().then(
        (resp) => {
          onSuccess(resp);
        },
        (error) => {
          ErrorHandler.handleError(error);
          onFailure(error);
        }
      );
    });
  }
}
